import numerologyTypeChange from './actions/numerologyTypeChange';
import numerologyTypeDetail from './actions/numerologyTypeDetail';
import numerologyTypesList from './actions/numerologyTypesList';
import getNumerologyTypes from './getters/getNumerologyTypes';
import numerologyTypesUpload from './mutations/numerologyTypesUpload';

const actions = {
    numerologyTypeChange,
    numerologyTypeDetail,
    numerologyTypesList
};

const mutations = {
    numerologyTypesUpload
};

const getters = {
    getNumerologyTypes
};

export default { actions, mutations, getters };
